import React, { Component } from "react" 
import { NavLink } from 'react-router-dom'

import { Logo, Img } from "../UI/UI";
import { isMobile } from "../../Utility/Utility";
import "./Menu.css";

const appCountrys = [
  {langCode: "de", subDomain: "de", countryName: "Deutsch"},
  // {langCode: "nl", subDomain: "nl", countryName: "Dutch"},
  // {langCode: "at", subDomain: "at", countryName: "Österreich"},
  // {langCode: "pl", subDomain: "pl", countryName: "Polski"},
  // {langCode: "ro", subDomain: "ro", countryName: "Română"},
  // {langCode: "se", subDomain: "se", countryName: "Svenska"},
  // {langCode: "ch", subDomain: "ch", countryName: "Schwyzerdütsch"},
  // {langCode: "cz", subDomain: "cz", countryName: "Cseh"},
  // {langCode: "dk", subDomain: "dk", countryName: "Danish"},
  // {langCode: "hu", subDomain: "hu", countryName: "Magyar"},
  {langCode: "gb", subDomain: "uk", countryName: "English"},
  {langCode: "ru", subDomain: "ru", countryName: "Русский"},
  {langCode: "fr", subDomain: "fr", countryName: "Français"},
  {langCode: "es", subDomain: "es", countryName: "Español"},
  {langCode: "it", subDomain: "it", countryName: "Italiana"},
  {langCode: "eu", subDomain: "eu", countryName: "الإمارات العربية المتحدة"},
  {langCode: "eu-en", subDomain: "eu-en", countryName: "United Arab Emirates"},
  {langCode: "pt", subDomain: "pt", countryName: "Portuguese"},
];

const CurrentFlagIcon = ( props ) => {
  var lang = ( props.lang ) ?  props.lang  : "" ;
  var langName = ( props.langName ) ?  props.langName  : "" ;
  var hideArrow = ( props.hideArrow === true ) ?  true  : false ;

  let arrow = null;

  if ( hideArrow === false ) {
    arrow = <Img desktopImg={'/right-arrow-wb.png'}  cssClass={'bottom-arrow'} />;
  }
  if ( isMobile() ){  
    return(
      <div className="flat-icon-div">
        <div className={'flat-icon-wrapper flat-icon-' + lang} >
          <button onClick={props.setLangState}>
            <Img desktopImg={'/flags/4x3/'+lang+'.svg'}  />
            <div>
              <p>
              {langName}
              </p>
            </div>
            {arrow}
          </button>
        </div>
      </div>
    )
  }else {
    return(
        <div className={'flat-icon-wrapper flat-icon-' + lang} >
          <button onClick={props.setLangState}>
            <Img desktopImg={'/flags/4x3/'+lang+'.svg'}  />
            <div>
              <p>
              {langName}
              </p>
            </div>
            {arrow}
          </button>
        </div>
    );
  }
}

class Menu extends Component {
  state = {
    isOpen : false ,
    isLangOpen: false
  }

  setMenuState = () => {
   if ( this.state.isLangOpen ){    
      this.setState({
        isLangOpen : !this.state.isLangOpen,
        isOpen : !this.state.isOpen
      })
    }else {
      this.setState({
        isOpen : !this.state.isOpen
      })
    }
  } 

  redirect = (subDomain) => {

     if( (subDomain === "ru" ) || (subDomain === "at" )|| (subDomain === "ch" ) || (subDomain === "it" )|| (subDomain === "en" ) || (subDomain === "pl" )  || (subDomain === "de" )  || (subDomain === "fr" )  || (subDomain === "es" ) || (subDomain === "eu" ) || (subDomain === "eu-en" )){
       
         window.location.href =  'https://new.goisrael.com/' + subDomain;

     }else  if( subDomain === "pt" ){
      window.location.href = 'https://goisrael.com.br/';
     }  else {

         window.location.href =  'https://goisrael.com/?lang=' + subDomain;
         // window.location.href =  'http://localhost:3000/international/?lang=' + subDomain;
     }

             
   }

  setLangState = () => {
    if ( isMobile() ){    
      this.setState({
        isLangOpen : !this.state.isLangOpen,
        isOpen : !this.state.isOpen
      })
    }else {
      this.setState({
        isLangOpen : !this.state.isLangOpen,
      })      
    }
  } 
  render(){

     const isLangOpen = this.state.isLangOpen;
    let cssClass ="inner";
    //  let parentCssClass ="";

    if ( this.state.isOpen === true ) {
      cssClass += " open"
    }

    var countryContainer = null;
    var countryCssClass = 'country-close';

    if ( isLangOpen ) {
        countryCssClass ='country-open'
        countryContainer = appCountrys.map((o) => {
          return  <CurrentFlagIcon lang={o.langCode} langName={o.countryName} setLangState={() => {
            this.redirect(o.subDomain)
          }} hideArrow ={true}  />
                
        })
    }

    var langName = 'fr';
    var langCode = 'fr';
    var CurrentLang = 'fr'

    if ( CurrentLang != null ) {
      langName = CurrentLang.toUpperCase();
      if ( CurrentLang === "fr"){
        langCode = 'fr';
      }else {
        langCode = CurrentLang;
      }
      
    }
    return(
     <div>
      {this.state.isLangOpen && <div className="nav-trigger-overlay" onClick={this.setLangState}></div>}
      <div className="menu-outer-wrapper">
        <div className="container">
          <div className="col col-15 logo-outer-wrapper">
            <NavLink  exact  className="first" to="/">
              <Logo />
            </NavLink>
          </div>
          <div className="col col-100 menu-inner-wrapper">
            <div className={cssClass}>
              <NavLink  exact  className="first" to="/">ACCUEIL</NavLink>
              <NavLink  exact to="/Pages/bestDeals">OFFRES SPÉCIALES</NavLink>
              <NavLink  exact to="/Pages/whereToGo">Où aller</NavLink>
              <NavLink  exact to="/Pages/thingsToDo">À faire</NavLink>
              <NavLink  exact to="/Pages/Gallery/">galerie photos</NavLink>
              <NavLink  exact to="/Pages/Videos">VIDÉOS</NavLink>
              <NavLink  exact to="/Pages/TouristInfoPage">INFORMATIONS TOURISTIQUES</NavLink>
              <CurrentFlagIcon lang={langCode} langName={langName} setLangState={this.setLangState} hideArrow={false}  />
              {/*<NavLink  exact to="/Pages/FAQ">FAQ</NavLink>*/}
              
            </div>
            <div className="show-on-mobile">
              <button className="open-mobile-menu navbar-toggle" onClick={this.setMenuState} >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
      <div className={'container country-container '  + countryCssClass}>
          <div className="country-container-inner">
            <div className="country-container-title">
              <h3>  
                Choose your language:
              </h3>
            </div>
            <div className="country-container-flags-wrapper">
              {countryContainer}
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default Menu


// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js